<template>
    <div class="index-bottom">
      <div class="display-flex justify-content-between def-width margin-center">
        <ul class="index-bottom-ul display-flex">
          <li class="display-flex" v-for="(item, index) in menuList" :key="index">
            <div class="color-FFFFFF font-16">{{item.msg}}</div>
            <div class="child-msg font-12">
              <div @click="goUrl(childItem)" class="child-msg-one cursor-pointer" v-for="(childItem, childIndex) in item.childItem" :key="childIndex">{{childItem.msg}}</div>
            </div>
          </li>
        </ul>
        <div class="index-bottom-right display-flex">
          <img class="code" :src="`../../static/talent/ewm.png`"/>
          <div>
            <div class="title font-16 bold">办公地点</div>
            <div class="address font-12">
              重庆总部：重庆市江北区江北嘴金融城3号T3<br/>
              深圳分公司：深圳市龙华区 民治街道优城商务大厦B座<br/>
              <div class="email font-12">
                简历可投递至邮箱：tangshuang01@inkankan.cn
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="provider font-12 display-flex justify-content-center">
        <div>COPYRIGHT 2024 INKANKAN.CN. 深圳侃侃文化传播有限公司版权所有</div>
        <a href="http://beian.miit.gov.cn" target="_blank">备案号 :粤ICP备18034084号-2</a>
      </div>
    </div>
</template>

<script>
import config from '@/config/index'
export default {
  imgURI: config.imgURI,
  name: 'website-bot',
  components: {
  },
  data () {
    return {
      // logImg: require('../../assets/index/wxcode.png'),
      menuList: [
        {
          msg: '关于我们',
          url: '/about',
          childItem: [
            {
              msg: '公司简介',
              name: 'profile',
              url: '/about'
            },
            {
              msg: '企业目标',
              name: 'goals',
              url: '/about'
            },
            {
              msg: '发展历程',
              name: 'history',
              url: '/about'
            }
          ]
        },
        {
          msg: '电商学院',
          url: '/collegeIntro',
          childItem: [
            {
              msg: '学院简介',
              name: 'profile',
              url: '/collegeIntro'
            },
            {
              msg: '学院优势',
              name: 'advantage',
              url: '/collegeIntro'
            }
          ]
        },
        {
          msg: '品牌出海',
          url: '/sea',
          childItem: [
            {
              msg: '品牌出海简介',
              name: 'profile',
              url: '/sea'
            },
            {
              msg: '特色服务',
              name: 'service',
              url: '/sea'
            }
          ]
        },
        {
          msg: '商务合作',
          url: '/businessIndex',
          childItem: [
            {
              msg: '线上资源',
              name: 'online',
              url: '/businessIndex'
            },
            {
              msg: '线下资源',
              name: 'offline',
              url: '/businessIndex'
            },
            {
              msg: '合作范围',
              name: 'cooperation',
              url: '/businessIndex'
            },
            {
              msg: '合作流程',
              name: 'process',
              url: '/businessIndex'
            },
            {
              msg: '联系我们',
              name: 'contact',
              url: '/businessIndex'
            }
          ]
        },
        {
          msg: '人才通道',
          url: '/talentIndex',
          childItem: [
            {
              msg: '企业文化',
              name: 'culture',
              url: '/talentIndex'
            },
            {
              msg: '加入我们',
              name: 'join',
              url: '/talentIndex'
            }
          ]
        }
      ]
    }
  },
  methods: {
    goUrl (i) {
      this.$router.push(`${i.url}?id=${i.name}`)
    }
  }
}
</script>

<style lang="scss" scoped>
    .index-bottom{
      background: #333333;
      font-size: 12px;
      color: #9e9e9e;
      padding: 60px 0;
    }
    a:link{
      color: #9e9e9e;
    }
    .index-bottom-ul{
      gap: 48px;
      li{
        flex-direction: column;
        gap: 20px;
      }
      .child-msg{
        color: #9e9e9e;
        line-height: 30px;
      }
      .child-msg-one:hover{
        color: #FFFFFF;
      }
    }
    .index-bottom-right{
      .code{
        width: 78px;
        height: 78px;
      }
      color: #9e9e9e;
      gap: 22px;
      .address{
        line-height: 20px;
      }
      .email{
        //color: #919191;
      }
    }
    .provider{
      margin-top: 40px;
      gap: 18px;
      color: #9e9e9e;
    }
</style>



// WEBPACK FOOTER //
// src/components/public/websiteBot.vue